import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { CardIcon, CircleTick, GrayTick, GreenTickImg } from '../utils/Images';
import CancelSubscription from '../components/CancelSubscription';
import { changeplan, createtrialsubscription, getpaymentmethods, getproductisting, getuserplandetails } from '../collection/ApiCollection';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader';

const ManageSubscription = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [openModal, setOpenModal] = useState(false);
    const [productListing, setProductListing] = useState(null);
    const [planDetail, setPlanDetail] = useState(null);
    console.log(planDetail, "planDetail")
    const [cardListing, setCardListing] = useState(null);
    const isFirstTimeSubscription = useSelector((state) => state?.Authlogin?.userDetail?.[0]?.subscription);
    console.log(isFirstTimeSubscription, "isFirstTimeSubscription")

    const handleOpenModal = () => {
        setOpenModal(true)
    }
    const handleCancelModal = () => {
        setOpenModal(false)
    }

    const handleGetCurrentPlan = async () => {
        try {
            setLoading(true)
            let res = await getuserplandetails();
            if (res.status === 200) {
                setPlanDetail(res?.data?.data?.[0]);
                setLoading(false)
            } else {
                setLoading(false)
                toast.error(res?.data?.response?.data?.message || res?.data?.error || res?.data?.message || "Something went wrong")
            }
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
        }
    }

    const handleGetAllCard = async () => {
        try {
            let res = await getpaymentmethods();
            if (res.status === 200) {
                setCardListing(res?.data?.data)
            } else {
                toast.error(res?.data?.response?.data?.message || res?.data?.error || res?.data?.message || "Something went wrong")
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
        }
    }

    // const handleCreateTrial = async (values) => {
    //     let req = {
    //         priceId: values?._id,
    //         productId: values?.productId
    //     }
    //     try {
    //         setLoading(true)
    //         let res = await createtrialsubscription(req);
    //         if (res.status === 200) {
    //             setLoading(false)
    //             toast.success(res?.message);
    //             handleGetProductListing()
    //             handleGetCurrentPlan()
    //         } else {
    //             setLoading(false)
    //             toast.error(res?.data?.response?.data?.message || res?.data?.error || res?.data?.message || "Something went wrong")
    //         }
    //     } catch (error) {
    //         setLoading(false)
    //         toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
    //     }
    // }

    const handleChangePlan = async (values) => {
        let req = {
            requestedPriceId: values?._id,
            requestedPlanId: values?.productId
        }
        try {
            setLoading(true)
            let res = await changeplan(req)
            if (res?.status === 200) {
                if (res?.data?.message?.url) {
                    window.open(res.data.message.url, "_blank");
                    setLoading(false)
                } else {
                    toast.success("Subscription change successfuly")
                    handleGetCurrentPlan()
                    setLoading(false)
                }
            } else {
                setLoading(false)
                toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
            }
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
        }
    }

    const handleGetProductListing = async () => {
        try {
            setLoading(true)
            let res = await getproductisting(20, 1)
            if (res.status === 200) {
                setProductListing(res?.data?.data?.data);
                setLoading(false)
            } else {
                setLoading(false)
                toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
            }
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
        }
    }

    useEffect(() => {
        handleGetProductListing();
        handleGetAllCard();
        handleGetCurrentPlan()
    }, [])

    return (
        <SubscriptionWrapper>
            {loading && <Loader />}
            {openModal && <CancelSubscription openModal={openModal} handleCancelModal={handleCancelModal} handleGetCurrentPlan={handleGetCurrentPlan} />}
            <h1 className='row-heading'>{planDetail?.subscriptions?.[0]?.priceDetails ? "Your current plan" : "Please select your trial plan"}</h1>
            <div className='row-one'>
                <div className='card'>
                    <h1 className='card-price'>${planDetail?.subscriptions?.[0]?.priceDetails?.amount || 0} <span>/{planDetail?.subscriptions?.[0]?.priceDetails?.interval}</span></h1>
                    <h1 className='plan'>{planDetail?.subscriptions?.[0]?.priceDetails?.name}</h1>
                    <div className='about-plan'>
                        <p><img src={CircleTick} alt="" />Includes {planDetail?.subscriptions?.[0]?.planServices?.[0]?.noOfCalls || 0} calls</p>
                        <p><img src={CircleTick} alt="" />{planDetail?.subscriptions?.[0]?.planServices?.[0]?.totalMinutes || 0} minutes each call</p>
                        <p><img src={CircleTick} alt="" />Pay-as-you-go applicable</p>
                    </div>
                </div>
            </div>
            <h1 className='row-heading'>Change your plan</h1>
            {productListing?.map((val, index) => {
                return (
                    <>
                        {index !== 2 && <p className='plan-name'>{val?.description}</p>}
                        {index !== 2 && <div className={index == 0 ? "row-flex" : "row-flex"}>
                            {val?.pricing?.map((el, indx) => {
                                return (
                                    <div className='card' style={{ background: indx === 0 ? "#DC3223" : indx === 2 ? "#5243C2" : "#0DA982" }}>
                                        <h1 className='card-price'>${el?.amount} <span>/{el?.interval}</span></h1>
                                        <h1 className='plan'>{el?.name}</h1>
                                        <div className='about-plan'>
                                            <p><img src={CircleTick} alt="" />Includes {el?.planServices?.noOfCalls} calls</p>
                                            <p><img src={CircleTick} alt="" />{el?.planServices?.totalMinutes} minutes each call</p>
                                            <p><img src={CircleTick} alt="" />Pay-as-you-go applicable</p>
                                        </div>
                                        <button style={{ color: "#DC3223", cursor: "pointer" }} onClick={() => handleChangePlan(el)}>
                                            SELECT
                                        </button>
                                    </div>
                                )
                            })}
                        </div>}

                    </>
                )
            })}
            {/* 
            <p className='plane-name-two'>For Assisted Living/Healthcare Providers</p>
            <div className='row-flex'>
                <div className='card' style={{ background: "#DC3223" }}>
                    <h1 className='card-price'>$399.99 <span>/month</span></h1>
                    <h1 className='plan'>Small Facility Plan</h1>
                    <div className='about-plan'>
                        <p><img src={CircleTick} alt="" />Includes 50 calls</p>
                        <p><img src={CircleTick} alt="" />30 minutes each call</p>
                        <p><img src={CircleTick} alt="" />Pay-as-you-go applicable</p>
                    </div>
                    <button style={{ color: "#DC3223" }}>
                        SELECT
                    </button>
                </div>
                <div className='card' style={{ background: "#0DA982" }}>
                    <h1 className='card-price'>$699.99 <span>/month</span></h1>
                    <h1 className='plan'>Medium Facility Plan</h1>
                    <div className='about-plan'>
                        <p><img src={CircleTick} alt="" />Includes 100 calls</p>
                        <p><img src={CircleTick} alt="" />30 minutes each call</p>
                        <p><img src={CircleTick} alt="" />Pay-as-you-go applicable</p>
                    </div>
                    <button style={{ color: "#0DA982" }}>
                        SELECT
                    </button>
                </div>
                <div className='card' style={{ background: "#490DA9" }}>
                    <h1 className='card-price'>Custom</h1>
                    <h1 className='plan'>Large Facility Plan</h1>
                    <div className='about-plan'>
                        <p><img src={CircleTick} alt="" />Unlimited calls based on price</p>
                        <p><img src={CircleTick} alt="" />30 minutes each call</p>
                        <p><img src={CircleTick} alt="" />Pay-as-you-go applicable</p>
                    </div>
                    <button style={{ color: "#490DA9" }}>
                        EXISTING PLAN
                    </button>
                </div>
            </div>*/}
            <h1 className="your-card">Your Cards</h1>
            <div className='card-div'>
                <div className='card-content'>
                    <h1 className='card-added'>Added cards</h1>
                    {cardListing && cardListing?.map((val, index) => {
                        return (
                            <div className='card-details'>
                                <div>
                                    {val?.isDefault ? <img src={GreenTickImg} alt="" width={24} height={24} className='img-1' /> : <img src={GrayTick} alt="" width={24} height={24} className='img-1' />}
                                    <img src={CardIcon} alt='' width={24} height={24} className='img-2' />
                                </div>
                                <div>
                                    <p>Card number</p>
                                    <h1>*******{val?.last4}</h1>
                                </div>
                                <div>
                                    <p>Card Holder’s Name</p>
                                    <h1>{val?.name_on_card}</h1>
                                </div>
                                <div>
                                    <p>Expiry Date</p>
                                    <h1>{val?.exp_year}</h1>
                                </div>
                            </div>
                        )
                    })}

                </div>
                <div className='add-new-card' onClick={() => navigate("/landing/add-new-card")}>
                    <h1><img src={GrayTick} alt="" />Add new card</h1>
                </div>
            </div>
            <div className="cancel-subscription">
                {planDetail?.subscriptions?.[0]?.status ? planDetail?.subscriptions?.[0]?.status == "canceled" ? <p style={{ color: "gray" }}>Cancel Subscription</p> : <p onClick={() => handleOpenModal()}>Cancel Subscription</p> : <p style={{ color: "gray" }}>Cancel Subscription</p>}

            </div>
        </SubscriptionWrapper>
    )
}

export default ManageSubscription;

const SubscriptionWrapper = styled.div`
    margin-top:97px;
    padding:0px 73px;
    .row-heading{
        font-weight:700;
        font-size:40px;
        text-align:center;
    }
    .plan-name{
        font-size:37px;
        margin-top:57px;
        text-align:center;
    }
    .plane-name-two{
        font-size:37px;
        margin-top:102px;
        margin-bottom:59px;
        text-align:center;
    }
    .row-one{
        display:flex;
        justify-content:center;
        margin-top:45px;
        margin-bottom:30px;

        .card{
            padding: 50px 30px 30px 30px;
            background: #0DA982;
            box-shadow: 0px 42px 34px 0px #5243C24B;
            border-radius:26px;
            max-width: 305px;
            width:100%;

            .card-price{
                color:#fff;
                font-weight:800;
                font-size:36px;
                
                span{
                    color:#fff;
                    font-size:17px;
                    font-weight:500;
                }
            }
            .plan{
                color:#fff;
                font-weight:700;
                font-size:28px;
                margin-top:20px;
            }
            .about-plan{
                margin-top:71px;
                display:flex;
                flex-direction:column;
                gap:11px;

                p{
                    color:#fff;
                    font-size:15px;
                    font-weight:500;
                    display:flex;
                    align-items:center;
                    gap:10px;
                    margin-bottom: 0px;

                    img{
                        width:20px;
                        height:20px;
                    }
                }
            }
        }
    }
    .row{
        display:grid;
        grid-template-columns: repeat(4, 1fr);
        gap:42px;
        margin-top:45px;
        margin-bottom:30px;

        @media (max-width: 1400px){
            grid-template-columns: repeat(3, 1fr);
        }
        @media (max-width: 1080px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
        }

        .card{
            padding: 50px 30px 30px 30px;
            background: #0DA982;
            box-shadow: 0px 42px 34px 0px #5243C24B;
            border-radius:26px;
            width: 100%;
            height:431px;
            position:relative;

            .card-price{
                color:#fff;
                font-weight:800;
                font-size:36px;

                @media (max-width: 750px){
                    font-size:28px;
                }
                
                span{
                    color:#fff;
                    font-size:17px;
                    font-weight:500;
                }
            }
            .plan{
                color:#fff;
                font-weight:700;
                font-size:28px;
                margin-top:20px;

                @media (max-width: 750px){
                    font-size:22px;
                }
            }
            .about-plan{
                margin-top:71px;
                display:flex;
                flex-direction:column;
                gap:11px;

                p{
                    color:#fff;
                    font-size:15px;
                    font-weight:500;
                    display:flex;
                    align-items:center;
                    gap:10px;

                    img{
                        width:20px;
                        height:20px;
                    }
                }
            }
            button{
                background:#fff;
                border-radius: 15px;
                box-shadow: 0px 10px 35px 0px #6F7EC940;
                height:48px;
                width: calc(100% - 67px);
                border:none;
                position:absolute;
                bottom:36px;
                left:35px;
                right:32px;
                font-weight:700;
                font-size:16px;
            }
        }
    }
    .row-flex{
        display:flex;
        justify-content:center;
        gap:42px;
        margin-top:45px;
        margin-bottom:30px;

        @media (max-width: 1200px){
            display:grid;
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
        }

        .card{
            padding: 50px 30px 30px 30px;
            background: #0DA982;
            box-shadow: 0px 42px 34px 0px #5243C24B;
            border-radius:26px;
            height:431px;
            position:relative;
            max-width: 305px;
            width:100%;

            .card-price{
                color:#fff;
                font-weight:800;
                font-size:36px;

                @media (max-width: 750px){
                    font-size:28px;
                }
                
                span{
                    color:#fff;
                    font-size:17px;
                    font-weight:500;
                }
            }
            .plan{
                color:#fff;
                font-weight:700;
                font-size:28px;
                margin-top:20px;

                @media (max-width: 862px){
                    font-size:22px;
                }
            }
            .about-plan{
                margin-top:71px;
                display:flex;
                flex-direction:column;
                gap:11px;

                p{
                    color:#fff;
                    font-size:15px;
                    font-weight:500;
                    display:flex;
                    align-items:center;
                    gap:10px;
                    margin-bottom: 0px;

                    img{
                        width:20px;
                        height:20px;
                    }
                }
            }
            button{
                background:#fff;
                border-radius: 15px;
                box-shadow: 0px 10px 35px 0px #6F7EC940;
                height:48px;
                width: calc(100% - 67px);
                border:none;
                position:absolute;
                bottom:36px;
                left:35px;
                right:32px;
                font-weight:700;
                font-size:16px;
            }
        }
    }
    .your-card{
        color:#000
        font-weight:700;
        font-size:40px;
        margin: 53px 0px;
        text-align:center;
    }
    .card-div{
        display:flex;
        align-items:center;
        justify-content:center;
        flex-direction:column;
        gap:24px;
        margin-bottom:36px;

        .add-new-card{
            max-width:700px;
            width:100%;
            border-radius: 16px;
            border: 1px solid #CFCFCF;
            padding: 24px 32px;
            cursor:pointer;

            h1{
                font-weight:700;
                font-size:16px;
                color:#000;
                display:flex;
                align-items:center;
                gap:16px;
                margin-bottom: 0px;

                img{
                    width:24px;
                    height:24px;
                }
            }
        }
        .card-content{
            max-width:700px;
            width:100%;
            border-radius: 16px;
            border: 1px solid #CFCFCF;
            overflow: auto;

            .card-added{
                font-weight:700;
                font-size:16px;
                color:#000;
                border-bottom: 1px solid #CFCFCF;
                padding: 24px 32px;
                @media (max-width: 707px){
                    border: none;
                }
            }
            .card-details{
                display:flex;
                justify-content:space-between;
                border-bottom: 1px solid rgb(207, 207, 207);
                div{
                padding: 16px 32px;
                @media (max-width: 706px){
                    border-top: 1px solid rgb(207, 207, 207);
                }
                    .img-1{
                        display:block;
                    }
                    .img-2{
                        display:block;
                        margin-top: 12px;
                    }
                    p{
                        color:#5E5E5E;
                        font-weight:400;
                        font-size:14px;
                        margin-bottom:0px;
                        white-space: nowrap;
                    }
                    h1{
                        color:#000000;
                        font-weight:700;
                        font-size:16px;
                        margin-top:20px;
                        margin-bottom:0px;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
    .cancel-subscription{
        p{
            color:#E40000;
            font-weight:500;
            font-size:25px;
            text-align:center;
            cursor:pointer;
        }
    }
`